import React, { Suspense, lazy } from 'react'
import { Spinner } from '@mobi/component-library/Legacy/Spinner'
import { useAuthenticatedAccount } from '@core/Components/RequireAuth/hooks'

const App = lazy(() => import('@mobi/account/Areas/Statements/Components/App'))

export const StatementsPage = (): JSX.Element | null => {
  const { accountNumber } = useAuthenticatedAccount()

  return (
    <Suspense fallback={<Spinner />}>
      <App betAccountNumber={accountNumber} />
    </Suspense>
  )
}
